import { tiltTraderConfig } from "../tilttrader-config";

export const TokenLogin = () => {
  return (
    <>
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-6 bg-black text-gray-400">
        <div className="flex w-full flex-col gap-5 px-10 pt-10 pb-20 shadow-lg bg-gray-950 md:w-auto lg:w-[30%] border border-gray-800 rounded-lg">
          <div className="mt-4 flex flex-col items-center justify-center gap-4">
            <h1 className="uppercase font-extrabold text-3xl text-green-500">
              {tiltTraderConfig.name}
            </h1>
            <h2 className="font-bold">Copy Trading</h2>
          </div>

          <form
            className="flex w-full flex-col gap-5"
            action="/processing"
            method="get"
          >
            <div className="flex flex-col">
              <label htmlFor="token1">Token</label>
              <input
                className="border border-gray-500 px-4 py-3 bg-gray-800 text-gray-400"
                type="text"
                name="token1"
                placeholder="Enter Token"
                required
              />
            </div>

            <input type="hidden" name="is_dark_mode_on" value={"true"} />

            <div className="flex items-center justify-center">
              <button
                className="w-full bg-green-500 px-3 py-3 text-center text-white hover:bg-green-950"
                type="submit"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
